









import { ChartData, ChartOptions } from 'chart.js'
import { Component, Prop, Vue } from 'vue-property-decorator'
import VChart from '@/components/molecules/VChart.vue'

@Component({
  components: {
    VChart,
  },
})
export default class ChartPane extends Vue {
  @Prop()
  data?: ChartData

  @Prop()
  options?: ChartOptions

  @Prop()
  type?: string

  get styles() {
    return {}
  }
}
